<template>
  <section>
    <el-table
      v-if="isLoading || loading || !bidsList.length"
      v-loading="isLoading || loading"
      :data="[]"
      style="width: 100%; height: 50vh"
    >
      <div slot="empty">
        <p v-if="!isError">В настоящее время погрузки отсутствуют</p>
        <template v-else>
          <p class="err-p"><b>Данные не загрузились</b></p>
          <el-button type="primary" @click="updatePage"> Обновить </el-button>
        </template>
      </div>
    </el-table>
    <template v-else>
      <shipping-item
        v-for="(item, i) in bidsList"
        :key="item.id"
        :cur-bid="item"
        :index="i"
        :is-archive="isArchive"
        v-on="$listeners"
        @editRegistryItem="editRegistry"
        @setHotItem="setHot"
        @addBidToLPItem="addBidToLP"
        @set="setBid"
        @fetch="fetchBids"
        @report="getReport"
        @openPaymentsBanksModal="openPaymentsBanksModal"
        @openDialogGenerateReport="openDialogGenerateReport"
        @ready="onReady(bidsList, i)"
        @openDialogSaveNomenclature="openDialogSaveNomenclature"
        @handleSelectedLoadDaysIds="handleSelectedLoadDaysIds"
        @client-updated="fetchBids"
        @set-paid="setPaid"
      />
    </template>
    <el-dialog
      title="Редактирование погрузки"
      :visible.sync="dialog_edit_shipping"
      width="70%"
    >
      <shipping :bids="bid" :step="step" :on-close="onClose" :edit="true" />
    </el-dialog>
    <bid-on-map
      :id="bid.id"
      :visible="openTheMap"
      @closed="onClose('openTheMap')"
    />
    <shipping-day-add
      :bid="bid"
      :visible="dialog_load_day"
      @close="onClose('dialog_load_day')"
    />
    <responses-list-modal
      :id="bid.id"
      :visible="dialogResponses"
      @close="onClose('dialogResponses')"
    />
    <send-notification-modal
      :bid="bid"
      :visible="dialogSendNotification"
      @close="onClose('dialogSendNotification')"
    />
    <choose-exporter
      :bid="bid"
      :visible="dialog_choose_exporter"
      @close="onClose('dialog_choose_exporter')"
    />
    <instruction-modal
      :id="bid.id"
      :visible="dialogInstruction"
      @close="onClose('dialogInstruction')"
      @update="fetchBids"
    />
    <contract-response-modal
      :id="bid.id"
      :visible="dialogContract"
      @close="onClose('dialogContract')"
      @update="fetchBids"
    />
    <report-submit
      :ids="load_days_ids"
      :fetch-bids="fetchBids"
      :visible="report_submitted"
      @close="onClose"
    />
    <payments-bank-modal
      v-if="paymentsBankModalVisible"
      :visible="paymentsBankModalVisible"
      :content="paymentsBankModalValue"
      @close="openPaymentsBanksModal"
    />
    <generate-report-modal
      v-if="generateReport.dialogVisible"
      :visible="generateReport.dialogVisible"
      :item="generateReport.item"
      @close="() => (generateReport.dialogVisible = false)"
    />
    <save-nomenclature
      :bid-id="bidIdForSaveNomenclature"
      :load-days-ids="selectedLoadDaysIds"
    />
    <add-registry-type
      :report-bid="reportBid"
      :visible="visibleRegisterModal"
      @close="visibleRegisterModal = false"
    />
  </section>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { isBidViewed } from '@/helpers/visibilityOnScroll'
import { mapGetters } from 'vuex'
import AddRegistryType from '@/components/Shared/AddRegistryType'
import BidOnMap from './Modals/BidOnMap'
import ChooseExporter from './Modals/ChooseExporter'
import ContractResponseModal from '@/views/Home/Shipping/Modals/ContractResponseModal.vue'
import GenerateReportModal from './Modals/GenerateReport/GenerateReport'
import InstructionModal from './Modals/InstructionModal'
import PaymentsBankModal from '@/components/Payments/Bank/Modal'
import ReportSubmit from '@/components/Forms/ReportSubmit'
import ResponsesListModal from './Modals/ResponsesListModal'
import SaveNomenclature from '@/views/LoadDay/Components/SaveNomenclature'
import SendNotificationModal from './Modals/SendNotificationModal'
import Shipping from './ShippingAdd'
import ShippingDayAdd from './Modals/ShippingDayAdd'
import ShippingItem from './Item/ShippingItem'
import shippingMixin from '@/mixins/shippingMixin'
const Bids = RepositoryFactory.get('bids')

export default {
  name: 'ShippingList',
  components: {
    AddRegistryType,
    SaveNomenclature,
    BidOnMap,
    ShippingItem,
    Shipping,
    ShippingDayAdd,
    ChooseExporter,
    ReportSubmit,
    InstructionModal,
    ContractResponseModal,
    PaymentsBankModal,
    ResponsesListModal,
    SendNotificationModal,
    GenerateReportModal,
  },
  mixins: [shippingMixin],
  props: {
    bidsList: {
      type: Array,
      default: () => [],
    },
    fetchBids: {
      type: Function,
      default: () => {},
    },
    isArchive: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visibleRegisterModal: false,
      reportBid: null,
      step: false,
      bid: {},
      load_days_ids: [],
      openTheMap: false,
      dialog_edit_shipping: false,
      dialog_load_day: false,
      dialog_choose_exporter: false,
      dialogInstruction: false,
      dialogContract: false,
      dialogResponses: false,
      dialogSendNotification: false,
      report_submitted: false,
      paymentsBankModalVisible: false,
      paymentsBankModalValue: {},
      generateReport: {
        dialogVisible: false,
        item: [],
      },
      bidIdForSaveNomenclature: null,
      selectedLoadDaysIds: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters({ isError: 'bids/isError', checkLibs: 'libs/checkLibs' }),
  },
  created() {
    this.$store.dispatch('managers/fetchManagers')
    this.$store.dispatch('organizations/fetchExporters')
  },
  methods: {
    setHot(item) {
      Bids.changeHotBid(item)
        .then(() => this.fetchBids())
        .catch(err => this.errHandler(err))
    },
    editRegistry(item) {
      this.reportBid = item.id
      this.visibleRegisterModal = true
    },
    addBidToLP(item) {
      Bids.addBidToLP(item)
        .then(() => this.fetchBids())
        .catch(err => this.errHandler(err))
    },
    handleSelectedLoadDaysIds(ids) {
      this.selectedLoadDaysIds = ids
    },
    updatePage() {
      this.fetchBids()

      if (!this.checkLibs) {
        this.$store.dispatch('libs/setLibs')
      }
      if (!this.getDocumentTypes.length) {
        this.$store.dispatch('documentTypes/init')
      }
    },
    onReady(bids, i) {
      if (i === bids.length - 1 && !this.isArchive) {
        isBidViewed(this)
      }
    },
    getReport(ids) {
      this.load_days_ids = ids
      this.report_submitted = true
    },
    setBid(bid, key, flag = false) {
      this.bid = bid
      this[key] = true
      this.step = flag
    },
    onClose(key) {
      this[key] = false
      this.step = false
      this.bid = {}
      this.load_days_ids = []
    },
    openPaymentsBanksModal(obj = {}) {
      this.paymentsBankModalValue = obj
      this.paymentsBankModalVisible = !this.paymentsBankModalVisible
    },
    openDialogGenerateReport(item = []) {
      this.generateReport.dialogVisible = true
      this.generateReport.item = item
    },
    openDialogSaveNomenclature(bidId) {
      this.bidIdForSaveNomenclature = bidId
    },
    setPaid(id) {
      this.loading = true
      Bids.setBidPaid(id)
        .then(() => this.fetchBids())
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
  },
}
</script>
